import React from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Popup } from '@shared/ui';

import { EstimateMeasurementsContext } from './Context/EstimateMeasurementsContext';
import cls from './EstimateMeasurements.module.css';
import { EstimateMeasurementsModal } from './EstimateMeasurementsModal/EstimateMeasurementsModal';
import { ImagePrev } from './UI/ImagePrev/ImagePrev';
import { useEstimateMeasurements } from './useEstimateMeasurements';
import { Loader } from '../../components/UI/NewLoader/Loader/Loader';

export const EstimateMeasurements = () => {
    const { t } = useTranslation();

    const { measurementsLoading, modalLoading } = useSelector((state) => state.measurementsReducer);
    const {
        isClosing,
        onHideModal,
        optionsList,
        estimateMeasurementsContext,
        isOpenModal,
        onHidePopup,
        isOpenPrevImage,
        isShowModal,
    } = useEstimateMeasurements();

    if (measurementsLoading) {
        return null;
    }
    return (
        <EstimateMeasurementsContext.Provider value={estimateMeasurementsContext}>
            {optionsList.length ? (
                <div
                    className={classNames(cls.container, {
                        [cls.show]: isShowModal,
                        [cls.hide]: isClosing,
                    })}
                >
                    {modalLoading && <Loader variant="light" />}
                    <button
                        type="button"
                        className={classNames(cls.ButtonCloseModal, 'settings-close')}
                        onClick={onHideModal}
                    >
                        <i className="la la-close" />
                    </button>
                    <EstimateMeasurementsModal />
                </div>
            ) : (
                <Popup
                    isOpen={isOpenModal}
                    onHidePopup={onHidePopup}
                    alertBtnText={t('EstimateMeasurements.Popup.cancel')}
                    contentText=" "
                >
                    <div className={cls.ModalTextBlock}>
                        <span>{t('EstimateMeasurements.Popup.span.not_measurements')}</span>
                        <br />
                        <span>{t('EstimateMeasurements.Popup.span.add_measurements')}</span>
                    </div>
                </Popup>
            )}
            {!!isOpenPrevImage && <ImagePrev />}
        </EstimateMeasurementsContext.Provider>
    );
};
